import { render, staticRenderFns } from "./GamepadSvg.vue?vue&type=template&id=64ef04ee&"
import script from "./GamepadSvg.vue?vue&type=script&lang=js&"
export * from "./GamepadSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports